import { formatDateTime } from "../../helpers/dateFormat";

export const getTransDtlsSoap = (xml) => {
  try {
    const errMsgNode = xml.getElementsByTagName("errMsg")[0];
    if (errMsgNode) {
      return { error: errMsgNode.textContent };
    }

    const product = xml.getElementsByTagName("prodId")[0]?.textContent || "N/A"
    const prodId = product.split("-")[0].trim();
    const productType = product.split('-').slice(1).join('-').trim();

    let packages = [];
    let isTransConfirmPlan = false;

    const packageNodes = xml.getElementsByTagName("packageDetails");

    if (packageNodes.length > 0) {
      // Multiple packages
      packages = Array.from(packageNodes).map((pkgNode) => {
        const planId = pkgNode.getAttribute("id") || "N/A";
        const plan = pkgNode.getElementsByTagName("planSelection")[0]?.textContent || "N/A";
        const premiumAmt = pkgNode.getElementsByTagName("premiumAmt")[0]?.textContent || "N/A";
        const obtainedCvr = pkgNode.getElementsByTagName("obtainedCvr")[0]?.textContent || "N/A";

        const coverageListItems = obtainedCvr
          .match(/[^,(]+(?:\([^)]*\))?[^,]*/g)
          ?.map(item => `<li>${item.trim()}</li>`) || [];

        return {
          planId,
          plan,
          premiumAmt,
          coverage: obtainedCvr,
          coverageList: `<ul>${coverageListItems.join("")}</ul>`,
        };
      });
    } else {
    // Single package (no <packageDetails> tag)
      const plan = xml.getElementsByTagName("planSelection")[0]?.textContent || "N/A";
      const premiumAmt = xml.getElementsByTagName("premiumAmt")[0]?.textContent || "N/A";
      const obtainedCvr = xml.getElementsByTagName("obtainedCvr")[0]?.textContent || "N/A";

      const coverageListItems = obtainedCvr
        .match(/[^,(]+(?:\([^)]*\))?[^,]*/g)
        ?.map(item => `<li>${item.trim()}</li>`) || [];

      packages.push({
        planId: "N/A",
        plan,
        premiumAmt,
        coverage: obtainedCvr,
        coverageList: `<ul>${coverageListItems.join("")}</ul>`
      });

      isTransConfirmPlan = true
    }

    return {
      carName: xml.getElementsByTagName("make")[0]?.textContent || "N/A",
      modelName: xml.getElementsByTagName("model")[0]?.textContent || "N/A",
      plateNumber: xml.getElementsByTagName("vehRegNo")[0]?.textContent || "N/A",
      plateCode: xml.getElementsByTagName("vehRegLOC")[0]?.textContent || "N/A",
      modelYear: xml.getElementsByTagName("modelYear")[0]?.textContent || "N/A",
      chassisNo: xml.getElementsByTagName("chasisNo")[0]?.textContent || "N/A",
      bodyType: xml.getElementsByTagName("vehBody")[0]?.textContent || "N/A",
      usageType: xml.getElementsByTagName("usage")[0]?.textContent || "N/A",
      vehicleValue: xml.getElementsByTagName("vehValue")[0]?.textContent || "N/A",
      insuredName: xml.getElementsByTagName("insureFullName")[0]?.textContent || "N/A",
      civilId: xml.getElementsByTagName("insuredLicNo")[0]?.textContent || "N/A",
      age: xml.getElementsByTagName("insuredAge")[0]?.textContent || "N/A",
      quoteNo: xml.getElementsByTagName("quoteNo")[0]?.textContent || "N/A",
      policyNo: xml.getElementsByTagName("policyNo")[0]?.textContent || "N/A",
      previousPolicyNo: xml.getElementsByTagName("previousPolicyNo")[0]?.textContent || "",
      coverFromDate: formatDateTime(xml.getElementsByTagName("effectiveDt")[0]?.textContent || "N/A"),
      coverToDate: formatDateTime(xml.getElementsByTagName("expirationDt")[0]?.textContent || "N/A"),
      quoteStatus: xml.getElementsByTagName("quoteStatus")[0]?.textContent || "N/A",
      product: product,
      packages: packages,
      prodId: prodId,
      productType: productType,
      // quoteStatus: xml.getElementsByTagName("quoteStatus")[0]?.textContent || "Quote",
      mobileNo: xml.getElementsByTagName("insuredMobileNo")[0]?.textContent || "N/A",
      eMailId: xml.getElementsByTagName("insuredEmailId")[0]?.textContent || "N/A",
      whatsappNo: "",
      isTransConfirmPlan,
    };
  } catch (error) {
    console.error("Error extracting data:", error);
    return { error: "Unexpected response format" };
  }
};